module.exports = __webpack_public_path__ + "img/sitImg.d77262cf.png";